import React from "react";
import Label from "../Common/Label";
import "./ImageAndContentIns.css";

const InstagramStoryContent: React.FC = () => {
  return (
    <>
      <div className="container mt-3">
        <div className="row">
          <div className="col-md-6">
            <div className="header-label">
              <Label
                children="Best Practices"
                fontWeight={600}
                fontSize="20px"
              />
            </div>
            <div className="list-items mt-2">
              <ul className="custom-list">
                <li>
                  <Label
                    children="Use high-resolution images to avoid pixelation."
                    fontSize="14px"
                    fontWeight={400}
                  />
                </li>
                <li>
                  <Label
                    children="Keep text concise (no more than 2-3 lines per screen)."
                    fontSize="14px"
                    fontWeight={400}
                  />
                </li>
                <li>
                  <Label
                    children="Use clear CTAs (e.g., 'Swipe up,'' 'Tap to see more')."
                    fontSize="14px"
                    fontWeight={400}
                  />
                </li>
                <li>
                  <Label
                    children="Use bold fonts and high contrast for better readability"
                    fontSize="14px"
                    fontWeight={400}
                  />
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <div className="header-label">
              <Label
                children="Restrictions "
                fontWeight={600}
                fontSize="20px"
              />
            </div>
            <div className="list-items mt-2">
              <div>
                <ul>
                  <li>
                    <Label
                      children="Image Format: JPG, PNG"
                      fontWeight={400}
                      fontSize="14px"
                    />
                  </li>

                  <li>
                    <Label
                      children="Aspect Ratio: 9:16 (Full-Screen Vertical)"
                      fontWeight={400}
                      fontSize="14px"
                    />
                  </li>

                  <li>
                    <Label
                      children="Resolution: 1080 x 1920 px (Recommended)"
                      fontWeight={400}
                      fontSize="14px"
                    />
                  </li>

                  <li>
                    <Label
                      children="Max File Size: 30MB"
                      fontWeight={400}
                      fontSize="14px"
                    />
                  </li>

                  <li>
                    <Label
                      children="Hashtags: Up to 10 per story"
                      fontWeight={400}
                      fontSize="14px"
                    />
                  </li>

                  <li>
                    <Label
                      children="Mentions (@username): Allowed"
                      fontWeight={400}
                      fontSize="14px"
                    />
                  </li>

                  <li>
                    <Label
                      children="Text Restrictions: No official limit, but keep it short for readability"
                      fontWeight={400}
                      fontSize="14px"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InstagramStoryContent;
